import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { has as _has, isEmpty as _isEmpty } from 'lodash';
import { useMobxStores } from '@stores/store';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CharacterSlide from '@organisms/main/CharacterSlide';
import { useKeenSlider } from 'keen-slider/react';
import WheelControls from '@molecules/slider/WheelControls';
import WithBTSBox from '@molecules/item/WithBTSMemberList';

const SectionWithBTS = ({ btsRef }) => {
  const { i18n, t } = useTranslation();
  const { devlogStore } = useMobxStores();
  const location = useLocation();
  let query = queryString.parse(location.search);
  const [onActiveIndex, setOnActiveIndex] = useState(0);
  const sectionStyle = {
    backgroundImage: 'url(/img/v2/main/withbts/pc_withbts_box_top.png)',
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
  };

  const member = [
    'RM',
    'JIN',
    'SUGA',
    'J-HOPE',
    'JIMIN',
    'V',
    'JUNGKOOK',
    'ARMY',
  ];

  const getInitialData = useCallback(
    async function (query) {
      const page = _has(query, 'page') ? parseInt(query.page) : 1;
      devlogStore.setListQuery('withBTSList', {
        ...query,
        page: page,
        category: member[onActiveIndex],
        lang: i18n.language,
        size: 100,
      });
      await devlogStore.getWithBTSList();

      return true;
    },
    [devlogStore, i18n.language, onActiveIndex]
  );

  useEffect(() => {
    const query = queryString.parse(location.search);
    getInitialData(query);
  }, [onActiveIndex, getInitialData, i18n.language]);

  return (
    <div className=" bg-[#f8f8f8] pb-[10px]">
      <section className="max-w-[1200px] m-auto with-bts-slide overflow-hidden ">
        <div
          style={sectionStyle}
          className="pt-[75px] xs:pt-[100px]  text-center pb-[20px] relative"
        >
          <p className="top-0 left-0 right-0 font-TmoneyRoundWind font-extrabold text-[#000] #xxxs:text-3xl text-4xl xs:text-5xl">
            {t('with BTS')}
          </p>
          <p className="text-[#575757] px-10 text-md sm:text-xl py-2">
            {t('BTS가 직접 작성한 개발 노트를 확인해 보세요!')}
          </p>
          <ul className="grid grid-cols-4 sm:grid-cols-8 text-center pt-10 with-bts-menu gap-5 gap-y-6 xs:gap-y-10 px-[30px] xs:px-[80px] ">
            <WithBTSBox
              onActiveIndex={onActiveIndex}
              setOnActiveIndex={setOnActiveIndex}
            />
          </ul>
        </div>
        <img
          src="/img/v2/main/withbts/pc_withbts_box_bottom.png"
          alt=""
          className="w-full"
        />

        <div className="pt-[50px] px-[15px] xs:px-[30px] main-withbts-wrap">
          {!_isEmpty(devlogStore.withBTSList) &&
            !_isEmpty(devlogStore.withBTSList.contents) && (
              <CharacterSlide
                count={4.8}
                data={devlogStore.withBTSList.contents}
              />
            )}
        </div>
      </section>
    </div>
  );
};

export default observer(SectionWithBTS);
